// extracted by mini-css-extract-plugin
module.exports = {"label":"vt","radioIcon":"vu","checked":"vv","inversedColors":"vw","radio":"vx","text":"vy"};